export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-grid-fill' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-fire-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-emotion-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-happy-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
  { slug: 'historical', name: '古风', icon: 'ri-landscape-line' },
  { slug: 'school', name: '校园', icon: 'ri-book-open-line' },
];

export const comics = [
  {
    id: '001',
    title: '她的私密世界',
    author: '金智恩',
    category: 'romance',
    tags: ['恋爱', '都市', '甜宠'],
    status: '连载中',
    rating: 9.2,
    views: 1285000,
    description: '平凡上班族李智雅偶然发现自己能进入暗恋对象的精神世界，在那里，她看到了他从未向任何人展示过的温柔与伤痛。一段穿越现实与心灵的治愈恋情就此展开。',
    chapters: [
      { num: 1, title: '第一话 - 偶然的发现', updatedAt: '2026-08-01' },
      { num: 2, title: '第二话 - 他眼中的世界', updatedAt: '2026-07-28' },
      { num: 3, title: '第三话 - 无法触及的心', updatedAt: '2026-07-25' },
      { num: 4, title: '第四话 - 靠近的温度', updatedAt: '2026-07-22' },
      { num: 5, title: '第五话 - 秘密花园', updatedAt: '2026-07-19' },
      { num: 6, title: '第六话 - 月光下的约定', updatedAt: '2026-07-16' },
      { num: 7, title: '第七话 - 心墙', updatedAt: '2026-07-13' },
      { num: 8, title: '第八话 - 温柔的陷阱', updatedAt: '2026-07-10' },
      { num: 9, title: '第九话 - 真相的碎片', updatedAt: '2026-07-07' },
      { num: 10, title: '第十话 - 破晓', updatedAt: '2026-07-04' },
    ],
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20in%20modern%20Seoul%20city%20setting%2C%20soft%20pastel%20pink%20and%20white%20color%20palette%2C%20romantic%20atmosphere%2C%20cherry%20blossom%20petals%20falling%2C%20delicate%20lineart%2C%20webtoon%20cover%20art%20style%2C%20clean%20white%20background%20with%20subtle%20gradient%2C%20elegant%20and%20dreamy%20mood&width=800&height=1120&seq=comic-cover-001&orientation=portrait',
  },
  {
    id: '002',
    title: '剑与魔法纪元',
    author: '朴志浩',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '热血'],
    status: '连载中',
    rating: 9.5,
    views: 2450000,
    description: '在剑与魔法并存的大陆上，少年艾伦意外觉醒了传说中的双生魔力。为了寻找失散多年的亲人，他踏上了充满未知与危险的冒险之旅。',
    chapters: [
      { num: 1, title: '第一话 - 觉醒之日', updatedAt: '2026-08-02' },
      { num: 2, title: '第二话 - 离开故乡', updatedAt: '2026-07-30' },
      { num: 3, title: '第三话 - 第一个伙伴', updatedAt: '2026-07-27' },
      { num: 4, title: '第四话 - 暗影森林', updatedAt: '2026-07-24' },
      { num: 5, title: '第五话 - 魔龙之巢', updatedAt: '2026-07-21' },
      { num: 6, title: '第六话 - 王都会议', updatedAt: '2026-07-18' },
      { num: 7, title: '第七话 - 遗迹之谜', updatedAt: '2026-07-15' },
      { num: 8, title: '第八话 - 宿命的对决', updatedAt: '2026-07-12' },
    ],
    cover: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20male%20warrior%20holding%20a%20glowing%20sword%2C%20magical%20energy%20surrounding%20him%2C%20dramatic%20lighting%2C%20dark%20blue%20and%20gold%20color%20scheme%2C%20dynamic%20pose%2C%20webtoon%20cover%20art%2C%20clean%20white%20background%2C%20powerful%20and%20heroic%20atmosphere&width=800&height=1120&seq=comic-cover-002&orientation=portrait',
  },
  {
    id: '003',
    title: '黑色星期五',
    author: '李贤宇',
    category: 'thriller',
    tags: ['悬疑', '犯罪', '推理'],
    status: '已完结',
    rating: 9.7,
    views: 3870000,
    description: '首尔江南区连续发生离奇失踪案，刑警姜道贤在调查过程中发现，所有线索都指向一个早已被宣告死亡的连环杀手。真相远比想象中更加骇人。',
    chapters: [
      { num: 1, title: '第一话 - 失踪者', updatedAt: '2026-06-15' },
      { num: 2, title: '第二话 - 第二个现场', updatedAt: '2026-06-12' },
      { num: 3, title: '第三话 - 目击者', updatedAt: '2026-06-09' },
      { num: 4, title: '第四话 - 交叉线索', updatedAt: '2026-06-06' },
      { num: 5, title: '第五话 - 地下迷宫', updatedAt: '2026-06-03' },
      { num: 6, title: '第六话 - 真相浮现', updatedAt: '2026-05-31' },
      { num: 7, title: '第七话 - 最终对决', updatedAt: '2026-05-28' },
      { num: 8, title: '第八话 - 结局·新的一天', updatedAt: '2026-05-25' },
    ],
    cover: 'https://readdy.ai/api/search-image?query=Dark%20thriller%20Korean%20manhwa%20style%20illustration%20of%20a%20detective%20in%20trench%20coat%20standing%20in%20rainy%20Seoul%20alleyway%20at%20night%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20mysterious%20silhouette%20in%20background%2C%20film%20noir%20atmosphere%2C%20webtoon%20cover%20art%20style%2C%20dark%20and%20moody%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-003&orientation=portrait',
  },
  {
    id: '004',
    title: '社长大人请自重',
    author: '崔美英',
    category: 'comedy',
    tags: ['搞笑', '职场', '恋爱'],
    status: '连载中',
    rating: 9.0,
    views: 1680000,
    description: '新人职员韩素希第一天上班就发现，传说中的冷血社长居然是大学时代被她拒绝过的学弟！更糟糕的是，这位社长似乎还在记仇……爆笑办公室恋情就此展开。',
    chapters: [
      { num: 1, title: '第一话 - 命运的再会', updatedAt: '2026-08-03' },
      { num: 2, title: '第二话 - 社长的特别关照', updatedAt: '2026-07-31' },
      { num: 3, title: '第三话 - 公司的流言', updatedAt: '2026-07-28' },
      { num: 4, title: '第四话 - 出差意外', updatedAt: '2026-07-25' },
      { num: 5, title: '第五话 - 酒后真言', updatedAt: '2026-07-22' },
      { num: 6, title: '第六话 - 旧情复燃', updatedAt: '2026-07-19' },
    ],
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20CEO%20in%20suit%20and%20a%20cute%20female%20office%20worker%2C%20funny%20and%20playful%20expressions%2C%20modern%20office%20setting%2C%20bright%20and%20cheerful%20color%20palette%2C%20webtoon%20cover%20art%20style%2C%20clean%20white%20background%2C%20lighthearted%20and%20humorous%20mood&width=800&height=1120&seq=comic-cover-004&orientation=portrait',
  },
  {
    id: '005',
    title: '校园之巅',
    author: '郑雨盛',
    category: 'action',
    tags: ['动作', '校园', '格斗'],
    status: '连载中',
    rating: 9.3,
    views: 1960000,
    description: '转学生金泰亨来到了一所被暴力支配的高中。为了守护珍视的人，他决定挑战学校的最强势力。一场席卷全校的热血格斗即将开始。',
    chapters: [
      { num: 1, title: '第一话 - 转校生', updatedAt: '2026-07-29' },
      { num: 2, title: '第二话 - 校园法则', updatedAt: '2026-07-26' },
      { num: 3, title: '第三话 - 第一战', updatedAt: '2026-07-23' },
      { num: 4, title: '第四话 - 联盟', updatedAt: '2026-07-20' },
      { num: 5, title: '第五话 - 决战前夕', updatedAt: '2026-07-17' },
      { num: 6, title: '第六话 - 顶点之战', updatedAt: '2026-07-14' },
      { num: 7, title: '第七话 - 新秩序', updatedAt: '2026-07-11' },
    ],
    cover: 'https://readdy.ai/api/search-image?query=Action%20Korean%20manhwa%20style%20illustration%20of%20a%20high%20school%20student%20in%20uniform%20with%20fists%20raised%20ready%20to%20fight%2C%20dynamic%20action%20pose%2C%20school%20building%20in%20background%2C%20intense%20red%20and%20black%20color%20scheme%2C%20webtoon%20cover%20art%20style%2C%20powerful%20and%20energetic%20mood%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-005&orientation=portrait',
  },
  {
    id: '006',
    title: '时光信笺',
    author: '尹恩惠',
    category: 'drama',
    tags: ['剧情', '时光', '治愈'],
    status: '已完结',
    rating: 9.6,
    views: 3120000,
    description: '一封来自十年前的信，改变了两个时空的命运。2026年的林秀雅与2016年的自己通过神秘的信笺建立联系，她们能否改变那些令人心碎的过去？',
    chapters: [
      { num: 1, title: '第一话 - 来自过去的信', updatedAt: '2026-06-20' },
      { num: 2, title: '第二话 - 两个时空', updatedAt: '2026-06-17' },
      { num: 3, title: '第三话 - 选择', updatedAt: '2026-06-14' },
      { num: 4, title: '第四话 - 蝴蝶效应', updatedAt: '2026-06-11' },
      { num: 5, title: '第五话 - 代价', updatedAt: '2026-06-08' },
      { num: 6, title: '第六话 - 终章·回信', updatedAt: '2026-06-05' },
    ],
    cover: 'https://readdy.ai/api/search-image?query=Emotional%20drama%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20holding%20an%20old%20letter%20with%20tears%20in%20her%20eyes%2C%20warm%20golden%20sunset%20light%2C%20vintage%20aesthetic%2C%20soft%20and%20melancholic%20color%20palette%2C%20webtoon%20cover%20art%20style%2C%20nostalgic%20and%20heartfelt%20mood%2C%20clean%20white%20background&width=800&height=1120&seq=comic-cover-006&orientation=portrait',
  },
  {
    id: '007',
    title: '花路',
    author: '朴彩英',
    category: 'daily',
    tags: ['日常', '治愈', '成长'],
    status: '连载中',
    rating: 8.9,
    views: 960000,
    description: '三个住在首尔合租房的女孩，在各自的追梦路上相遇、碰撞、成长。平凡的日子因彼此的陪伴而闪闪发光，这是一部关于友情与梦想的温暖故事。',
    chapters: [
      { num: 1, title: '第一话 - 新室友', updatedAt: '2026-07-30' },
      { num: 2, title: '第二话 - 各自的早晨', updatedAt: '2026-07-27' },
      { num: 3, title: '第三话 - 失败也没关系', updatedAt: '2026-07-24' },
      { num: 4, title: '第四话 - 屋顶的星空', updatedAt: '2026-07-21' },
      { num: 5, title: '第五话 - 第一个好消息', updatedAt: '2026-07-18' },
      { num: 6, title: '第六话 - 我们的小确幸', updatedAt: '2026-07-15' },
    ],
    cover: 'https://readdy.ai/api/search-image?query=Slice%20of%20life%20Korean%20manhwa%20style%20illustration%20of%20three%20young%20women%20laughing%20together%20in%20a%20cozy%20apartment%2C%20warm%20sunlight%20streaming%20through%20window%2C%20plants%20and%20books%20around%2C%20soft%20pastel%20colors%2C%20webtoon%20cover%20art%20style%2C%20warm%20and%20comforting%20mood%2C%20clean%20white%20background&width=800&height=1120&seq=comic-cover-007&orientation=portrait',
  },
  {
    id: '008',
    title: '红月之夜',
    author: '韩志敏',
    category: 'historical',
    tags: ['古风', '宫廷', '权谋'],
    status: '连载中',
    rating: 9.4,
    views: 2100000,
    description: '朝鲜王朝时期，一位出身寒微的医女被卷入宫廷的权力斗争。在红月之夜，她做出了改变命运的选择，从此踏上了充满荆棘的复仇之路。',
    chapters: [
      { num: 1, title: '第一话 - 进宫', updatedAt: '2026-07-28' },
      { num: 2, title: '第二话 - 尚宫的秘密', updatedAt: '2026-07-25' },
      { num: 3, title: '第三话 - 毒药', updatedAt: '2026-07-22' },
      { num: 4, title: '第四话 - 红月之宴', updatedAt: '2026-07-19' },
      { num: 5, title: '第五话 - 棋局', updatedAt: '2026-07-16' },
      { num: 6, title: '第六话 - 同盟', updatedAt: '2026-07-13' },
      { num: 7, title: '第七话 - 揭发', updatedAt: '2026-07-10' },
      { num: 8, title: '第八话 - 新局', updatedAt: '2026-07-07' },
    ],
    cover: 'https://readdy.ai/api/search-image?query=Historical%20Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20woman%20in%20traditional%20Joseon%20dynasty%20hanbok%20dress%2C%20standing%20in%20ancient%20palace%20courtyard%20under%20red%20moon%2C%20elegant%20and%20mysterious%20atmosphere%2C%20traditional%20Korean%20aesthetic%2C%20webtoon%20cover%20art%20style%2C%20dramatic%20and%20refined%20mood%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-008&orientation=portrait',
  },
  {
    id: '009',
    title: '交换日记',
    author: '金秀贤',
    category: 'school',
    tags: ['校园', '青春', '成长'],
    status: '已完结',
    rating: 9.1,
    views: 1560000,
    description: '高二的春天，班长朴智旻和转学生郑夏恩因为一本交换日记而开始了解彼此不为人知的一面。青涩的校园恋情在笔尖悄然绽放。',
    chapters: [
      { num: 1, title: '第一话 - 交换日记的规则', updatedAt: '2026-05-30' },
      { num: 2, title: '第二话 - 隔壁班的你', updatedAt: '2026-05-27' },
      { num: 3, title: '第三话 - 图书馆的秘密', updatedAt: '2026-05-24' },
      { num: 4, title: '第四话 - 运动会', updatedAt: '2026-05-21' },
      { num: 5, title: '第五话 - 毕业旅行', updatedAt: '2026-05-18' },
      { num: 6, title: '第六话 - 最后的日记', updatedAt: '2026-05-15' },
    ],
    cover: 'https://readdy.ai/api/search-image?query=Youth%20romance%20Korean%20manhwa%20style%20illustration%20of%20a%20boy%20and%20girl%20in%20school%20uniform%20exchanging%20notebooks%20under%20cherry%20blossom%20tree%2C%20spring%20setting%2C%20soft%20pink%20and%20green%20colors%2C%20webtoon%20cover%20art%20style%2C%20innocent%20and%20sweet%20mood%2C%20clean%20white%20background&width=800&height=1120&seq=comic-cover-009&orientation=portrait',
  },
  {
    id: '010',
    title: '魔女的条件',
    author: '张瑞希',
    category: 'fantasy',
    tags: ['奇幻', '魔法', '恋爱'],
    status: '连载中',
    rating: 9.3,
    views: 1850000,
    description: '现代首尔隐藏着一个不为人知的魔法世界。实习魔女李夏恩必须在六个月内找到一个真心爱她的人，否则将永远失去魔力。然而，爱情从来不是魔法能够解决的问题。',
    chapters: [
      { num: 1, title: '第一话 - 魔女的契约', updatedAt: '2026-08-01' },
      { num: 2, title: '第二话 - 咖啡店邂逅', updatedAt: '2026-07-29' },
      { num: 3, title: '第三话 - 魔法失误', updatedAt: '2026-07-26' },
      { num: 4, title: '第四话 - 他的秘密', updatedAt: '2026-07-23' },
      { num: 5, title: '第五话 - 满月之夜', updatedAt: '2026-07-20' },
      { num: 6, title: '第六话 - 倒计时', updatedAt: '2026-07-17' },
      { num: 7, title: '第七话 - 真心', updatedAt: '2026-07-14' },
      { num: 8, title: '第八话 - 新的魔法', updatedAt: '2026-07-11' },
    ],
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20romance%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20witch%20girl%20with%20floating%20magical%20sparkles%20around%20her%2C%20modern%20Seoul%20cityscape%20at%20night%20in%20background%2C%20purple%20and%20gold%20magical%20effects%2C%20webtoon%20cover%20art%20style%2C%20enchanting%20and%20mysterious%20mood%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-010&orientation=portrait',
  },
  {
    id: '011',
    title: '第四十三次告白',
    author: '宋慧乔',
    category: 'romance',
    tags: ['恋爱', '甜宠', '喜剧'],
    status: '连载中',
    rating: 8.8,
    views: 1120000,
    description: '暗恋了三年，告白了四十二次，全都被拒绝了。第四十三次告白，姜素拉决定用最特别的方式让学长记住她。这一次，她不会再退缩。',
    chapters: [
      { num: 1, title: '第一话 - 第四十二次失败', updatedAt: '2026-07-31' },
      { num: 2, title: '第二话 - 终极计划', updatedAt: '2026-07-28' },
      { num: 3, title: '第三话 - 意料之外', updatedAt: '2026-07-25' },
      { num: 4, title: '第四话 - 他的反应', updatedAt: '2026-07-22' },
      { num: 5, title: '第五话 - 第四十三次', updatedAt: '2026-07-19' },
    ],
    cover: 'https://readdy.ai/api/search-image?query=Cute%20romantic%20Korean%20manhwa%20style%20illustration%20of%20a%20shy%20girl%20holding%20a%20love%20letter%20behind%20her%20back%2C%20blushing%20face%2C%20university%20campus%20setting%2C%20spring%20season%2C%20soft%20pink%20tones%2C%20webtoon%20cover%20art%20style%2C%20sweet%20and%20fluttery%20mood%2C%20clean%20white%20background&width=800&height=1120&seq=comic-cover-011&orientation=portrait',
  },
  {
    id: '012',
    title: '末日后的一年',
    author: '赵寅成',
    category: 'action',
    tags: ['动作', '科幻', '生存'],
    status: '连载中',
    rating: 9.4,
    views: 2230000,
    description: '末日降临一年后，幸存者们在这片废土上建立了新的秩序。曾经的医生崔俊昊在废墟中救了一个神秘少女，她的血液中藏着人类最后的希望。',
    chapters: [
      { num: 1, title: '第一话 - 废墟', updatedAt: '2026-08-02' },
      { num: 2, title: '第二话 - 感染者', updatedAt: '2026-07-30' },
      { num: 3, title: '第三话 - 聚集地', updatedAt: '2026-07-27' },
      { num: 4, title: '第四话 - 远征队', updatedAt: '2026-07-24' },
      { num: 5, title: '第五话 - 实验室', updatedAt: '2026-07-21' },
      { num: 6, title: '第六话 - 背叛', updatedAt: '2026-07-18' },
      { num: 7, title: '第七话 - 最后的据点', updatedAt: '2026-07-15' },
    ],
    cover: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20Korean%20manhwa%20style%20illustration%20of%20a%20survivor%20man%20in%20torn%20clothes%20standing%20in%20destroyed%20city%20ruins%2C%20dramatic%20orange%20sunset%20sky%2C%20dust%20and%20debris%2C%20intense%20and%20gritty%20atmosphere%2C%20webtoon%20cover%20art%20style%2C%20powerful%20composition%2C%20clean%20background&width=800&height=1120&seq=comic-cover-012&orientation=portrait',
  },
];

export const faqList = [
  {
    question: '韩漫网站有哪些类型的漫画？',
    answer: '韩漫网站涵盖恋爱、奇幻、动作、剧情、搞笑、悬疑、日常、古风、校园等多种类型，满足不同读者的阅读偏好。',
  },
  {
    question: '漫画阅读收费吗？',
    answer: '韩漫网站目前所有漫画均免费阅读，无需注册即可畅享全部内容。我们致力于为漫画爱好者提供优质的免费阅读体验。',
  },
  {
    question: '什么是下拉式阅读模式？',
    answer: '下拉式阅读是韩漫网站的特色浏览方式，读者只需向下滑动页面即可连续阅读漫画内容，无需翻页，提供更加流畅自然的阅读体验。',
  },
  {
    question: '在手机上阅读体验如何？',
    answer: '韩漫网站采用智能加载技术和响应式设计，完美适配手机、平板和电脑等各类设备。竖屏阅读模式尤其适合手机用户，随时随地享受韩漫乐趣。',
  },
  {
    question: '漫画更新频率是多少？',
    answer: '连载中的漫画通常每周更新一话，具体更新时间因作品而异。您可以在漫画详情页查看最新更新日期。',
  },
  {
    question: '如何反馈问题或提出建议？',
    answer: '您可以通过关于我们页面的联系表单与我们取得联系，我们会认真对待每一条用户反馈，持续优化阅读体验。',
  },
];

export const testimonials = [
  {
    name: '漫画爱好者小王',
    comment: '这个网站的下拉式阅读太流畅了！用手机看韩漫非常方便，推荐给了好多朋友。',
    rating: 5,
  },
  {
    name: '资深漫友小李',
    comment: '分类做得很好，找漫画特别方便。画质也很清晰，阅读体验一级棒。',
    rating: 5,
  },
  {
    name: '韩漫新人小张',
    comment: '朋友推荐的这个网站，一开始只是试试看，结果一发不可收拾，每天都在追更新。',
    rating: 5,
  },
  {
    name: '忠实读者小陈',
    comment: '更新速度很快，翻译质量也很高。希望网站越做越好，会一直支持的！',
    rating: 4,
  },
];